export const dateUtils = {
    // 2025-04-02T05:22:22.000+00:00 형식을 yyyy-MM-dd로 변환
    formatDate: (date, separator) => {
        if (!date) return '';

        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');

        let result = `${year}-${month}-${day}`

        if(separator){
            const hour = String(dateObj.getHours()).padStart(2, '0')
            const min = String(dateObj.getMinutes()).padStart(2, '0')
            const sec = String(dateObj.getSeconds()).padStart(2, '0')
            result = result + ` ${hour}${separator}${min}${separator}${sec}`
        }

        return result
    }
};
